import { render } from "./SolarSystemVisualization.vue?vue&type=template&id=22a7888e"
import script from "./SolarSystemVisualization.vue?vue&type=script&lang=js"
export * from "./SolarSystemVisualization.vue?vue&type=script&lang=js"

import "./SolarSystemVisualization.vue?vue&type=style&index=0&id=22a7888e&lang=css"

import exportComponent from "/home/wsl-ubuntu/work-repos/ats-201-build-a-planet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__